import React from 'react';
import { Box, Typography } from '@material-ui/core';

export const CircuitBreakerTooltip = ({ circuitBreaker }) => {
  return (
    <Box display="flex" gridGap={12} width="fit-content">
      <div>
        <strong>
          <u>
            <Typography variant="body1">Legend</Typography>
          </u>
        </strong>
        <Typography variant="body2">
          <span role="img" aria-label="Closed circuit breaker indicator">
            🟢
          </span>{' '}
          = <em>closed</em>
        </Typography>
        <Typography variant="body2">
          <span role="img" aria-label="Half-open circuit breaker indicator">
            🟡
          </span>{' '}
          = <em>half-open</em>
        </Typography>
        <Typography variant="body2">
          <span role="img" aria-label="Open circuit breaker indicator">
            🔴
          </span>{' '}
          = <em>open</em>
        </Typography>
      </div>
      <div>
        <strong>
          <u>
            <Typography variant="body1">Information</Typography>
          </u>
        </strong>
        <div>
          <Box display="flex" gridGap={6}>
            <Typography variant="body2">
              <em>Recovery Threshold:</em>
            </Typography>
            <Typography variant="body2">
              {circuitBreaker.recoveryThreshold}
            </Typography>
          </Box>
          <Box display="flex" gridGap={6}>
            <Typography variant="body2">
              <em>Failure Threshold:</em>
            </Typography>
            <Typography variant="body2">
              {circuitBreaker.failureThreshold}
            </Typography>
          </Box>
          <Box display="flex" gridGap={6}>
            <Typography variant="body2">
              <em>Failure Timeout:</em>
            </Typography>
            <Typography variant="body2">
              {circuitBreaker.failureTimeoutMins} mins
            </Typography>
          </Box>
          <br />
          <Box display="flex" gridGap={6}>
            <Typography variant="body2">
              <em>Consecutive Failures:</em>
            </Typography>
            <Typography variant="body2">
              {circuitBreaker.consecutiveFailures}
            </Typography>
          </Box>
          <Box display="flex" gridGap={6}>
            <Typography variant="body2">
              <em>Test Jobs Processed:</em>
            </Typography>
            <Typography variant="body2">
              {circuitBreaker.testJobsProcessed}
            </Typography>
          </Box>
        </div>
      </div>
    </Box>
  );
};
